export const MAX_COLOR_COUNT = 14
export const MAX_LOGO_COUNT = 7
